"use client";
import "./CashGiftModal.css";
import AsoEbiModal from "../../Modals/asoEbiModal/AsoEbiModal";

const CashGiftModal = ({ visible, onClose, onSubmit, initialBankDetails }) => {
  const handleSave = (data) => {
    // Add your save logic here
    console.log("Saving data:", data);
    onSubmit({
      bankDetails: {
        bankName: "Example Bank",
        accountNumber: "1234567890",
        accountName: "John Doe",
      },
    });
    onClose();
  };

  return (
    <AsoEbiModal
      visible={visible}
      onClose={onClose}
      title="Cash Gift"
      subtitle="Important notes on Cash Gifts"
      requirements={{
        title: "How Cash Gifts Work",
        items: [
          {
            title: "Provide Bank Information:",
            description:
              "Please provide your bank details to receive cash gifts from your guests.",
          },
          {
            title: "Note: ",
            description:
              "All cash gifts would be forwarded to the provided account when requested.",
          },
        ],
      }}
      uploadSection={null}
      refundPolicySection={null}
      showActionButtons={true}
      onImageUpload={() => []}
      onSave={handleSave}
      initialBankDetails={initialBankDetails}
      modalSmallHeightMultiplier={0.6}
    />
  );
};

export default CashGiftModal;
